import DummyReactComponent from './DummyReactComponent';
import CartRhs from './CartRhs/CartRhs';
import Cart from './Cart/Cart';
import OpenCart from './CartRhs/OpenCart';
import AddToCartButton from './AddToCartButton/AddToCartButton';
import SocialShare from './SocialShare/SocialShare';
import RecentItems from './RecentItems/RecentItems';
import CartUpsell from './CartUpsell/CartUpsell';

export default {
  DummyReactComponent,
  CartRhs,
  Cart,
  OpenCart,
  AddToCartButton,
  SocialShare,
  RecentItems,
  CartUpsell,
};
